import { Box, Typography, useTheme } from "@mui/material";
import CommentBulb from "./comment-bulb";
import ExpandableItemsList from "./expandable-items-list";
import {
  commentBulbBackgroundMap,
  commentBulbColorMap,
} from "@/modules/lead-page/new/constants";
import {
  PropertyPriceUpdateContent,
  PropertyPriceUpdateInfoProps,
} from "@/modules/lead-page/types";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";

const PropertyPriceUpdateInfo = ({ item }: PropertyPriceUpdateInfoProps) => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  let parsedContent: PropertyPriceUpdateContent | null;
  try {
    parsedContent = item.content ? JSON.parse(item.content) : null;
    if (!parsedContent) return null;
  } catch (error) {
    return null;
  }

  const trackItems = parsedContent.trackUIds.map((uid) => ({
    title: uid,
    link: `/property-tracks/${uid}?tab=Activity`,
  }));

  return (
    <>
      {trackItems.length > 0 && (
        <Box
          sx={{
            display: isMobile ? "block" : "flex",
            gap: theme.nawy.spacing.xxs,
          }}
        >
          <Typography
            sx={{
              color: theme.nawy.colors.semantic.text.primary,
              ...theme.nawy.typography.english.variants.body.sm.semibold,
              minWidth: "fit-content",
            }}
          >
            Tracks:
          </Typography>
          <ExpandableItemsList items={trackItems} />
        </Box>
      )}

      {parsedContent.summary && (
        <Box sx={{ marginTop: theme.nawy.spacing.xs }}>
          <CommentBulb
            content={parsedContent.summary}
            backgroundColor={commentBulbBackgroundMap.get("default")}
            color={commentBulbColorMap.get("default")}
            mentions={item.mentions}
          />
        </Box>
      )}
    </>
  );
};

export default PropertyPriceUpdateInfo;
